<script setup lang="ts">
const props = defineProps({
  imagesPreload: {
    type: Object as () => { url: string }[],
    required: true,
  },
});
const imagesPreloadArr = ref([]);
const preloadImages = () => {
  const promises = props.imagesPreload.map((urlItem) => {
    return new Promise((resolve, reject) => {
      const url = urlItem.url;
      const image = new Image();
      image.src = url;
      image.onload = () => resolve({ url });
      image.onerror = (error) => reject(error);
    });
  });
  Promise.all(promises)
    .then((imag) => {
      imagesPreloadArr.value = imag as { url: string }[];
    })
    .catch((error) => {
      console.error('Error loading images:', error);
    });
};
onMounted(async () => {
  preloadImages();
});
</script>

<template>
  <slot />
</template>

<style scoped lang="scss"></style>
